import React, { PropsWithChildren } from 'react';
import { NativeProps } from '@/src/components/interfaces';
import classNames from 'classnames';
import { CBox } from '@/src/components/c-box/CBox';
import { CFlex, FlexDirection } from '@/src/components/c-flex/CFlex';

export enum CSwiperCardSize {
  Lg = 'lg',
  Md = 'md',
  Sm = 'sm',
}

export interface CSwiperCardProps extends NativeProps {
  size?: CSwiperCardSize;
  image?: React.JSX.Element;
  title?: React.JSX.Element;
  footer?: React.JSX.Element;
}

export function CSwiperCard(props: PropsWithChildren<CSwiperCardProps>): React.JSX.Element {
  const size = props.size ?? CSwiperCardSize.Md;

  return (
    <div
      id={props.id}
      onClick={props.onClick}
      style={props.style}
      data-test-selector={props.testSelector}
      className={classNames('c-card', props.class, {
        [`c-card--size-${size}`]: size,
      })}
    >
      <CBox class={classNames('c-card__image', {
        'c-image-placeholder': !props.image,
      })}>
        {props.image}
      </CBox>
      <CBox class="c-card__content c-padding--md">
        <CFlex class="c-gap--sm" direction={FlexDirection.Column}>
          <CBox class="c-card__title">
            {props.title}
          </CBox>
          <CBox class="c-card__footer">
            {props.footer}
          </CBox>
        </CFlex>
      </CBox>
    </div>
  );
}
